import klineApiService from '@/request/kline/kline.api.service';
import { useEffect, useState } from 'react';
import { IKline } from '@/request/kline/kline.response.interface';
import { IKlineReq } from '@/request/kline/kline.request.interface';
import { useTradeStore } from '@/page/trade/store';

export const useFetchKineData = (params: IKlineReq) => {
  const [klineData, setKlineData] = useState<IKline[]>([]);
  const [loading, setLoading] = useState(false);
  const { setTokenRealtimePrice } = useTradeStore();

  const fetchData = async () => {
    try {
      if (params.tokenAddress) {
        setLoading(true);
        const res = await klineApiService.getKlineApi(params);
        if (res.code == 0) {
          setKlineData(res.data);
          setLoading(false);
          setTokenRealtimePrice(res.data[res.data.length - 1].close as string);
        }
      }
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [params]);

  return {
    klineData,
    loading,
    setKlineData,
    fetchData,
  };
};
